import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gs_alert_bar = _resolveComponent("gs-alert-bar")!
  const _component_gs_button = _resolveComponent("gs-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.selectedPlan && _ctx.otherStoresNeedSpendingLimitUpdate)
      ? (_openBlock(), _createBlock(_component_gs_alert_bar, {
          key: 0,
          class: "mt-4",
          type: "info",
          title: _ctx.t('update_other_stores_limit_title'),
          message: _ctx.t('update_other_stores_limit_description')
        }, null, 8, ["title", "message"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_gs_button, {
        onClick: _ctx.goToMyAccount,
        type: "primary",
        size: "large",
        "full-width": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('my_account')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}